<template>
    <!-- Start Why Chose Us
    ============================================= -->
    <div class="choseus-area default-padding-top">
      <div class="container">
        <div class="choseus-box">
          <div class="row">
            <div class="col-lg-5 info">
              <h5 style="text-transform: none">
                ¿Necesitas asesoria en tecnología remota?
              </h5>
              <h2>Somos expertos en la nube para aplicaciones de escritorio</h2>
              <p>
                Vapp es una plataforma de administración de software en la que
                puedes alojar todas tus herramientas tecnológicas y controlar tu
                empresa con total seguridad. Accede de manera remota vía web
                mediante todo tipo de dispositivo: computador, tablet,
                smartphone, etc. incluso si no es el que usas en forma habitual.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Why Chose Us -->
</template>


<script>
    export default {
        name: "Banner3",
        components: {},
        beforeMount() {},
    };
</script>